import PropTypes from 'prop-types';
import React, { useRef, useEffect } from 'react';

const useClickAwayListener = ({ ref, onClickAway }) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        // @WORKAROUND Fix react-datepicker no official non-portal solution
        // Exclusions
        const target = event.target;

        if (
          (!!target.className.includes && target.className.includes('react-datepicker')) ||
          (!!target.parentElement.className.includes &&
            target.parentElement.className.includes('toastrContent'))
        ) {
          return;
        }

        onClickAway(event);
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, onClickAway]);
};

const ClickAwayListener = ({ onClickAway, children, containerClass = '' }) => {
  const wrapperRef = useRef(null);

  useClickAwayListener({
    ref: wrapperRef,
    onClickAway: onClickAway,
  });

  return (
    <div ref={wrapperRef} className={containerClass}>
      {children}
    </div>
  );
};

ClickAwayListener.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ClickAwayListener;
